"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInLine = exports.isInFacebook = void 0;
function isInFacebook() {
  if (typeof window !== 'undefined' && window.navigator) {
    var _a = window.navigator.userAgent,
      userAgent = _a === void 0 ? '' : _a;
    if (/FBAN|FBAV/g.test(userAgent)) {
      return true;
    }
  }
  return false;
}
exports.isInFacebook = isInFacebook;
function isInLine() {
  if (typeof window !== 'undefined' && window.navigator) {
    var _a = window.navigator.userAgent,
      userAgent = _a === void 0 ? '' : _a;
    if (/Line/g.test(userAgent)) {
      return true;
    }
  }
  return false;
}
exports.isInLine = isInLine;